import React, { useState } from 'react';
import { theme } from '@style/theme';
import { Expand } from 'lucide-react';
import { StyledIconButton } from '@/components';
import { ThumbnailImageProps } from '@/lib/imageGallery';
import { Tooltip } from '@mui/material';

interface GalleryImageProps extends ThumbnailImageProps {
  onOpenLightbox: () => void;
  onDoubleClick?: () => void;
}

export const GalleryImage = ({
  imageProps,
  item,
  onOpenLightbox,
  onDoubleClick,
}: GalleryImageProps) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const tooltipText = (item as any).tooltipText || imageProps?.title || '';
  return (
    <div
      style={{
        border: item.isSelected ? '1px solid var(--primary-color)' : theme.border.light,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        style={{
          position: 'relative',
          overflow: 'hidden',
          backgroundColor: 'white',
          height: '100%',
          cursor: 'pointer',
          padding: '4px',
        }}
        onDoubleClick={onDoubleClick}
      >
        <Tooltip title={tooltipText} arrow>
          <img
            {...imageProps}
            title={null}
            key={imageProps.key}
            style={{
              ...imageProps.style,
              width: '100%',
              objectFit: 'contain',
              transition: 'transform 0.3s ease',
              marginLeft: '0 !important',
            }}
            alt={imageProps.alt}
          />
        </Tooltip>
        {isHovered && (
          <StyledIconButton>
            <Expand
              fill={'black'}
              onClick={(e) => {
                e.stopPropagation();
                onOpenLightbox();
              }}
            />
          </StyledIconButton>
        )}
      </div>
      {item.caption && (
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            background: 'rgba(0, 0, 0, 0.6)',
            color: 'white',
            fontSize: '12px',
            textAlign: 'center',
            padding: '5px 0',
            transition: 'opacity 0.3s ease',
          }}
        >
          {item.caption}
        </div>
      )}
    </div>
  );
};
